const e = {
  internalKey: {
    type: [String, Number],
    required: !0
  },
  root: Boolean,
  isGroup: Boolean,
  level: {
    type: Number,
    required: !0
  },
  title: [String, Function],
  extra: [String, Function]
};
export {
  e as useMenuChildProps
};
